import React, { Component } from 'react';

import * as MuiCore from '@material-ui/core';

// import ProfileIcon from '@material-ui/icons/AccountCircle';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import * as Formatters from '../ui/Formatters';

import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as coreActions from '../core/actions';
import * as accountActions from '../account/actions';

const styles = theme => ({
    topLevel : {
        // position: 'absolute',
        // top: 0,
        // right: 0,
        // bottom: 0,
        // left: 0,
        minHeight:'100%',
        flexGrow:1,
        display:'flex',
        // borderRadius: 20,
        padding: 0,
    },
    title : {
        ...theme.typography.h6,
        fontWeight: 'bold',
        paddingLeft: 20,
        paddingRight: 20,
    },
    reverseTextField : {
        color: 'black',
        '& input' : {
          color: 'black !important',
        },
        '& label' : {
          color: 'black !important',
        },
        '& fieldset' : {
          borderColor: 'black !important',
          borderWidth: 2,
        }
      },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <MuiCore.Slide direction="left" ref={ref} {...props} />;
  });

class UserProfile extends Component {

    state = {
        setPinOpen : false,
        settingPin : false,
        newPin : '',
        mouseState: 'left',
        resetPasswordOpen: false,
        currentPassword: '',
        newPassword: '',
        repeatPassword: '',
        showCurrentPassword: false,
        showNewPassword: false,
      }

    changeNewPin = (event) => {
        let newPin = event.target.value.replace(/\D/g,'').substring(0,6);
        this.setState({ newPin });
    }

    openSetPin = () => {
        this.setState({ setPinOpen: true, settingPin: false, newPin: ''});
    }

    setPin = () => {
        this.setState({ settingPin: true});
        this.props.changeAccessPin(this.state.newPin, () => {
            this.setState({ settingPin: false, setPinOpen:  false});
        }, () => {
            this.setState({ settingPin: false});
        });

    }

    render() {
        const { classes, user, changePassword, postSnackMessage } = this.props;

        return (
            <React.Fragment>
            <MuiCore.Dialog open={this.state.resetPasswordOpen}
                    onClose={() => this.setState({resetPasswordOpen: false})}
                     fullWidth style={{padding: 20}}>
                <MuiCore.DialogTitle>
                    <span style={{fontFamily: 'Sofia-bold'}}>Change Password</span>
                </MuiCore.DialogTitle>
                <MuiCore.DialogContent>
                    <MuiCore.Grid container>
                        <MuiCore.Grid item lg={5} md={5}>
                        {/* <MuiCore.FormControl style={{margin: 5}}>
                            <MuiCore.OutlinedInput
                                placeholder='Current Password'
                                type={this.state.showCurrentPassword ? 'text' : 'password'}
                                value={this.state.currentPassword}
                                inputProps={{ style: {fontFamily: 'Sofia', fontSize: 14, padding: 5, margin: 10}}}
                                onChange={(event) => this.setState({currentPassword: event.target.value})}       
                                endAdornment={
                                <MuiCore.InputAdornment position="end">
                                    <MuiCore.IconButton
                                        size='small'
                                        aria-label="toggle password visibility"
                                        onClick={() => this.setState({showCurrentPassword: !this.state.showCurrentPassword})}
                                    >
                                    {this.state.showCurrentPassword ? <Visibility /> : <VisibilityOff />}
                                    </MuiCore.IconButton>
                                </MuiCore.InputAdornment>
                                }
                            />
                        </MuiCore.FormControl> */}
                        <MuiCore.FormControl style={{margin: 5, marginTop: 15}}>
                            <MuiCore.OutlinedInput
                                placeholder='New Password'
                                type={this.state.showNewPassword ? 'text' : 'password'}
                                value={this.state.newPassword}
                                inputProps={{ style: {fontFamily: 'Sofia', fontSize: 14, padding: 5, margin: 10}}}
                                onChange={(event) => this.setState({newPassword: event.target.value})}       
                                endAdornment={
                                <MuiCore.InputAdornment position="end">
                                    <MuiCore.IconButton
                                        size='small'
                                        aria-label="toggle password visibility"
                                        onClick={() => this.setState({showNewPassword: !this.state.showNewPassword})}
                                    >
                                    {this.state.showNewPassword ? <Visibility /> : <VisibilityOff />}
                                    </MuiCore.IconButton>
                                </MuiCore.InputAdornment>
                                }
                            />
                        </MuiCore.FormControl>
                        <MuiCore.FormControl style={{margin: 5, marginTop: 15}}>
                            <MuiCore.OutlinedInput
                                placeholder='Verify New Password'
                                type={this.state.showNewPassword ? 'text' : 'password'}
                                value={this.state.repeatPassword}
                                inputProps={{ style: {fontFamily: 'Sofia', fontSize: 14, padding: 5, margin: 10}}}
                                onChange={(event) => this.setState({repeatPassword: event.target.value})}       
                                endAdornment={
                                <MuiCore.InputAdornment position="end">
                                    <MuiCore.IconButton
                                        size='small'
                                        aria-label="toggle password visibility"
                                        onClick={() => this.setState({showNewPassword: !this.state.showNewPassword})}
                                    >
                                    {this.state.showNewPassword ? <Visibility /> : <VisibilityOff />}
                                    </MuiCore.IconButton>
                                </MuiCore.InputAdornment>
                                }
                            />
                        </MuiCore.FormControl>
                        </MuiCore.Grid>
                        <MuiCore.Grid item lg={1} md={1}>
                            <MuiCore.Divider orientation='vertical'></MuiCore.Divider>
                        </MuiCore.Grid>
                         <MuiCore.Grid item lg={6} md={6} style={{padding: 0}}>
                            <MuiCore.Typography style={{fontFamily: 'Sofia', fontSize: 15}}>Please make sure your new password:</MuiCore.Typography>
                            <ul>
                                <li style={{fontFamily: 'Sofia', fontSize: 15, color: this.state.newPassword.length >= 8 && this.state.newPassword.length <= 16 ? 'green' : null}}>8-16 characters</li>
                                <li style={{fontFamily: 'Sofia', fontSize: 15,  color: /[A-Z]/.test(this.state.newPassword) ? 'green' : null}}>Contains 1 upper Case</li>
                                <li style={{fontFamily: 'Sofia', fontSize: 15,  color: /[a-z]/.test(this.state.newPassword) ? 'green' : null}}>Contains 1 lower Case</li>
                                <li style={{fontFamily: 'Sofia', fontSize: 15,  color: /[0-9]/.test(this.state.newPassword) ? 'green' : null}}>Contains 1 number</li>
                                <li style={{fontFamily: 'Sofia', fontSize: 15,  color: this.state.newPassword === this.state.repeatPassword && this.state.newPassword !== '' ? 'green' : null}}>Verify password matches</li>
                            </ul>
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                </MuiCore.DialogContent>
                <MuiCore.DialogActions>
                <MuiCore.Button disabled={(!(this.state.newPassword.length >= 8 && this.state.newPassword.length <= 16 && /[a-z]/.test(this.state.newPassword) && /[A-Z]/.test(this.state.newPassword) && /[0-9]/.test(this.state.newPassword)))
                                            || (this.state.newPassword !== this.state.repeatPassword
                                            && this.state.newPassword !== '')}
                                onClick={() => {changePassword(this.state.newPassword, () => {
                                    this.setState({resetPasswordOpen: false})
                                    postSnackMessage('success', 'Password changed successfully');
                                })}}>
                                Save
                </MuiCore.Button>
                <MuiCore.Button onClick={() => this.setState({resetPasswordOpen: false})}>
                                Cancel
                </MuiCore.Button>
                </MuiCore.DialogActions>
            </MuiCore.Dialog>
            <MuiCore.Grid item xs={12}>
                <div className={classes.topLevel}>
                    <MuiCore.Grid container direction='column'
                        wrap='nowrap'
                        style={{height: '100%'}}
                      alignItems = 'stretch'>
                        <MuiCore.Grid item style={{marginBottom: 10}}>
                            <MuiCore.Grid container direction='row'>
                                {/* <MuiCore.Grid item>
                                    <ProfileIcon/>
                                </MuiCore.Grid> */}
                                <MuiCore.Grid item>
                                    <div className={classes.title} style={{fontFamily: 'Sofia-bold', fontSize: 24, fontWeight: 300}}>
                                    User Information
                                    </div>
                                </MuiCore.Grid>
                            </MuiCore.Grid>            
                        </MuiCore.Grid>
                        <MuiCore.Grid style={{marginLeft: 20}}>
                            <MuiCore.Typography variant='body1' style={{fontFamily: 'Sofia', fontWeight: 'bold'}}>
                                {user.displayName}
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily: 'Sofia', marginTop: 5, width: '50%'}}>
                                {user.jobTitle}
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily: 'Sofia', marginTop: 5, width: '50%'}}>
                                {user.selfContact[0]?.contactMethods?.filter(method => method.contactMethodType === 'PHONE').map((item, index) => (
                                    <span key={index} style={{marginRight: 20}}>
                                        {Formatters.formatPhoneNumber(item.phoneNumber)}
                                        {(index+1)%4===0 && <br/>}
                                    </span>
                                ))}
                            </MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily: 'Sofia', width: 300}}>
                                {user.selfContact[0]?.contactMethods?.filter(method => method.contactMethodType === 'EMAIL').map((item, index) => (
                                    <span key={index} style={{marginRight: 20}}>
                                        {item.email}
                                        {(index+1)%3===0 && <br/>}
                                    </span>
                                ))}
                            </MuiCore.Typography>
                            {/* <MuiCore.Grid container direction='row'>
                                <MuiCore.Typography variant='body1' style={{marginTop: 20, fontFamily: 'Sofia', fontWeight: 700}}>
                                    {`User PIN: ${user.accessPin}`}
                                </MuiCore.Typography>
                                <MuiCore.Grid item xs={4} style={{marginLeft: 20, marginTop: 10}}>
                                    <MuiCore.Button disabled={Boolean(agentUserSession)} onClick={this.openSetPin}>Change PIN</MuiCore.Button>
                                </MuiCore.Grid>
                            </MuiCore.Grid> */}
                            <MuiCore.Typography className={classes.filterText} style={{fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'updatePassword' ? '#E5196C' : '#09122B', fontWeight: 400, marginBottom: 70, marginTop: 20, marginRight: 30}}>
                                <span style={{cursor: 'pointer'}} onClick={() => this.setState({resetPasswordOpen: true})} onMouseEnter={()=>{this.setState({mouseState: 'updatePassword'})}} onMouseLeave={()=>{this.setState({mouseState: 'left'})}}>
                                    {'Update Password'}
                                </span>
                            </MuiCore.Typography>
                            {/* <MuiCore.Typography variant='body1' style={{marginTop: 20, fontWeight: 'bold', marginBottom: 20}}>
                                {`Inbound Phone Numbers`}
                            </MuiCore.Typography>
                            <MuiCore.TableContainer>
                                <MuiCore.Table padding='checkbox'>
                                    <MuiCore.TableHead>
                                    <MuiCore.TableRow>
                                        <MuiCore.TableCell>Phone Number</MuiCore.TableCell>
                                        <MuiCore.TableCell>Status</MuiCore.TableCell>
                                    </MuiCore.TableRow>
                                    </MuiCore.TableHead>
                                    
                                    <MuiCore.TableBody>
                                    {(account.phoneNumbers || []).map(phoneNumber => (
                                        <MuiCore.TableRow key={phoneNumber.phoneNumberId}>
                                        <MuiCore.TableCell>{Formatters.formatPhoneNumber(phoneNumber.phoneNumber)}</MuiCore.TableCell>
                                        <MuiCore.TableCell>{phoneNumber.status}</MuiCore.TableCell>
                                        </MuiCore.TableRow>
                                    ))}
                                    </MuiCore.TableBody>
                                </MuiCore.Table>
                            </MuiCore.TableContainer> */}
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                </div>
            </MuiCore.Grid>
            <MuiCore.Dialog open={this.state.setPinOpen}
                            maxWidth="xs"
                            fullWidth
                            onClose={() => this.setState({setPinOpen : false})}
                            TransitionComponent={Transition}>
            <MuiCore.DialogTitle style={{fontFamily: 'Sofia-bold', color: '#000'}}>Set PIN</MuiCore.DialogTitle>
            
            <MuiCore.DialogContent>
                <MuiCore.Typography variant='body1' style={{fontFamily: 'Sofia', color: '#000'}}>
                The PIN is must be 4-6 digits.
                </MuiCore.Typography>
                <MuiCore.TextField style={{marginTop: 10}}
                                value={this.state.newPin}
                                onChange={this.changeNewPin}
                                className={classes.reverseTextField}
                                placeholder='PIN'
                                InputProps={{ style: {fontFamily: 'Sofia', fontSize: 14}}}
                                fullWidth />
            </MuiCore.DialogContent>
            <MuiCore.DialogActions>
                <MuiCore.Button
                disabled={this.state.newPin.length < 4 || this.state.settingPin}
                onClick={this.setPin}>
                Set PIN
                </MuiCore.Button>
                <MuiCore.Button
                onClick={() => this.setState({setPinOpen : false})}>
                Cancel
                </MuiCore.Button>
            </MuiCore.DialogActions>
            </MuiCore.Dialog>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
      user : coreSelectors.getUser(state),
      agentUserSession : coreSelectors.getAgentUserSession(state),
      accountId: accountSelectors.getAccountId(state),
      account: accountSelectors.getAccount(state)
    });
  };
  
  const mapDispatchToProps = {
    setAccountId: accountActions.setAccountId,
    saveEditAccount: accountActions.saveEditAccount,
    queryAccount: accountActions.queryAccount,
    changeAccessPin : coreActions.changeAccessPin,
    setManualPasswordChange : coreActions.setManualPasswordChange,
    changePassword: coreActions.changePassword,
    postSnackMessage: coreActions.postSnackMessage,
  };

  export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserProfile));